(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function initSlideshow(hero) {
      if (hero.dataset.swInit) return;
      hero.dataset.swInit = 'true';
      var total = parseInt(hero.dataset.totalSlides) || 1;
      if (total <= 1) {
        var first = hero.querySelector('[data-slide="0"]');
        if (first) { first.style.display = 'block'; first.style.opacity = '1'; }
        return;
      }
      var slides = Array.from(hero.querySelectorAll('[data-slide]'));
      var dots = Array.from(hero.querySelectorAll('[data-dot]'));
      var prevBtn = hero.querySelector('.hero__sw-prev');
      var nextBtn = hero.querySelector('.hero__sw-next');
      var autoplay = hero.dataset.autoplay === 'true';
      var speed = parseInt(hero.dataset.autoplaySpeed) || 5000;
      var current = 0; var timer = null; var isAnimating = false;

      slides.forEach(function(slide, i) {
        slide.style.transition = 'opacity 0.8s ease';
        slide.style.display = i === 0 ? 'block' : 'none';
        slide.style.opacity = i === 0 ? '1' : '0';
      });

      function show(index) {
        if (isAnimating) return;
        isAnimating = true;
        var prev = current;
        current = (index + total) % total;
        if (dots[prev]) dots[prev].classList.remove('hero__sw-dot--active');
        if (dots[current]) dots[current].classList.add('hero__sw-dot--active');
        var prevSlide = slides[prev]; var nextSlide = slides[current];
        nextSlide.style.display = 'block'; nextSlide.style.opacity = '0';
        requestAnimationFrame(function() {
          requestAnimationFrame(function() {
            prevSlide.style.opacity = '0'; nextSlide.style.opacity = '1';
            setTimeout(function() { prevSlide.style.display = 'none'; isAnimating = false; }, 800);
          });
        });
      }

      function startAutoplay() { stopAutoplay(); timer = setInterval(function() { show(current + 1); }, speed); }
      function stopAutoplay() { if (timer) { clearInterval(timer); timer = null; } }

      if (prevBtn) prevBtn.addEventListener('click', function(e) { e.preventDefault(); e.stopPropagation(); stopAutoplay(); show(current - 1); if (autoplay) startAutoplay(); });
      if (nextBtn) nextBtn.addEventListener('click', function(e) { e.preventDefault(); e.stopPropagation(); stopAutoplay(); show(current + 1); if (autoplay) startAutoplay(); });
      dots.forEach(function(dot) { dot.addEventListener('click', function(e) { e.preventDefault(); stopAutoplay(); show(parseInt(dot.dataset.dot)); if (autoplay) startAutoplay(); }); });

      var startX = 0;
      hero.addEventListener('touchstart', function(e) { startX = e.touches[0].clientX; }, { passive: true });
      hero.addEventListener('touchend', function(e) {
        var diff = startX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 40) { stopAutoplay(); show(diff > 0 ? current + 1 : current - 1); if (autoplay) startAutoplay(); }
      });
      hero.addEventListener('mouseenter', stopAutoplay);
      hero.addEventListener('mouseleave', function() { if (autoplay) startAutoplay(); });
      if (autoplay) startAutoplay();
    }

    function scanAndInit() { document.querySelectorAll('[data-total-slides]').forEach(initSlideshow); }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', scanAndInit); } else { scanAndInit(); }
    document.addEventListener('shopify:section:load', function(e) {
      var hero = e.target.querySelector('[data-total-slides]');
      if (hero) { delete hero.dataset.swInit; initSlideshow(hero); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
